import { Auth } from 'aws-amplify';

import { mapMutations } from 'vuex';

import AuthenticationService from '../services/authentication';

export default (to: any, from: any, next: any) =>
Auth.currentSession()
  .then((data: any) => {

        /*console.log('data', data);
        return;*/
       AuthenticationService.setUsername(data.idToken.payload.email);
       AuthenticationService.setUserSession(data);
       AuthenticationService.setToken(data.idToken.jwtToken);
       const { userGroups } = AuthenticationService;
       const isActiveUser = !!userGroups && (userGroups.indexOf('User') !== -1 || userGroups.indexOf('Users') !== -1 || userGroups.indexOf('user') !== -1 || userGroups.indexOf('users') !== -1);
       const isSysAdmin = !!userGroups && userGroups.indexOf('SysAdmin') !== -1;
       const isDevAdmin = !!userGroups && userGroups.indexOf('DevAdmin') !== -1;
       if (isActiveUser || isSysAdmin || isDevAdmin) {
      next();
      return;
    }
       const redirectRoute = {
      path: '/401',
    };
       next(redirectRoute);
  })
  .catch((err) => {
    // tslint:disable-next-line: no-console
    console.log(err);
    // tslint:disable-next-line: no-console
    console.log('is Auth error', err);
    const redirectRoute = {
      path: '/login',
      query: {
        redirect: to.fullPath,
      },
    };
    next(redirectRoute);
  });

